import { render, staticRenderFns } from "./DiseasesHealthInformation.vue?vue&type=template&id=c1c39840&scoped=true"
import script from "./DiseasesHealthInformation.vue?vue&type=script&lang=js"
export * from "./DiseasesHealthInformation.vue?vue&type=script&lang=js"
import style0 from "./DiseasesHealthInformation.vue?vue&type=style&index=0&id=c1c39840&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c39840",
  null
  
)

export default component.exports